export default "__VITE_ASSET__ab648a67__"